module.exports = __webpack_public_path__ + "static/media/dashboardHistory_en.f8f23094.png";